import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MenuItem, MenuItemExtended, ChildMenuGroup } from '../../../base/models/menu-items';
import { UserContext } from '../../../auth/models/auth';

@Component({
  selector: 'app-list-menu',
  templateUrl: './list-menu.component.html',
  styleUrls: ['./list-menu.component.scss']
})
export class ListMenuComponent {
  @Input() menuItems: MenuItem[]
  @Input() user: UserContext
  @Input() salesRep: boolean
  @Input() languages: string[]

  @Output() onToggleNavBar = new EventEmitter<boolean>()
  @Output() onToggleMobileUserOptions = new EventEmitter<boolean>()
  @Output() onSelectCustomer = new EventEmitter()
  @Output() onItemClick = new EventEmitter<void>()

  menuItemsExtended: MenuItemExtended[] = [];

  constructor() { }

  get topMenus(): MenuItem[] {
    if (this.menuItems && this.menuItems.length > 0) {
      return this.menuItems.filter(menu => menu.parent === null)
    }

    return []
  }

  hasChildMenus(menuItem: MenuItem): boolean {
    // Check if menu has children.
    if (menuItem.children && menuItem.children.length > 0) {
      // Menu item has children but they also need to be of the type 'top' or 'both.
      const children = this.menuItems.filter(function (menuItem) {
        return this.indexOf(menuItem.code) >= 0 && (menuItem.type === 'top' || menuItem.type === 'both');
      }, menuItem.children);

      return children.length > 0;
    }

    return false
  }

  getChildMenus(menuItem: MenuItem): MenuItem[] {
    if (this.menuItems && this.menuItems.length > 0) {
      return this.menuItems.filter(function (item) {
        return this.indexOf(item.code) > -1
      }, menuItem.children)
    }

    return []
  }


  getChildMenuGroups(menuItem: MenuItem): ChildMenuGroup[] {

    let childMenuGroups: ChildMenuGroup[] = []

    let nrOfGroups: number = Math.ceil(menuItem.children.length / 8);
    let startSlice = 0;
    let endSlice = 8;

    for (let i = 0; i < nrOfGroups ; i++) {

      let childrenForGroup: string[] = menuItem.children.slice(startSlice,endSlice);

      if (childrenForGroup.length > 0)
      {
        let childGroup: ChildMenuGroup = { sortOrder: 1, children: childrenForGroup }
        childMenuGroups.push(childGroup);

        startSlice += 8;
        endSlice += 8;
      }
    }



    return childMenuGroups
  }


  onClickMenu(menu: MenuItem) {
    if (this.hasChildMenus(menu)) {
      this.toggleSubMenu()
    } else {
      this.toggleNavBar()
    }
  }

  toggleNavBar() {
    this.toggleSubMenu();
    this.onToggleNavBar.emit()
  }

  toggleMobileUserOptions() {
    this.onToggleMobileUserOptions.emit();
  }

  toggleSubMenu(menu?: MenuItem) {
    if (menu) {
      // First make other possible menus inactive
      const otherMenus = this.menuItemsExtended.filter((otherMenu => otherMenu._id !== menu._id))
      otherMenus.forEach(otherMenu => {
        otherMenu.isActive = false
      })

      let menuItemExtended = this.menuItemsExtended.find(menuExtended => menuExtended._id === menu._id);

      if (menuItemExtended) {
        menuItemExtended.isActive = !menuItemExtended.isActive;
      } else {
        const menuItemExtended: MenuItemExtended = {
          ...menu,
          isActive: true
        }
        this.menuItemsExtended.push(menuItemExtended);
      }
    } else {
      // Sub menu item clicked, emit this.
      this.onItemClick.emit()

      this.menuItemsExtended.forEach(menu => {
        menu.isActive = false;
      })
    }
  }

  showSubMenu(menu: MenuItem) {
    if (this.menuItemsExtended.length) {
      const menuItemExtended = this.menuItemsExtended.find(menuExtend => menuExtend._id === menu._id)
      if (menuItemExtended) {
        return menuItemExtended.isActive
      }
    }

    return false
  }
}
